// extracted by mini-css-extract-plugin
module.exports = {"contexts-menu":"contexts-menu___2u6VZ","trigger":"trigger___3GcxZ","context":"context___3-fFT","triangle-icon":"triangle-icon___2kFdk","name":"name___3sbfx"};